module.exports = __webpack_public_path__ + "img/startuj_white.57d08a58.png";